import EmailIcon from '@mui/icons-material/Email';
import { LoadingButton } from '@mui/lab';
import { Box, Collapse, Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, Grid, Icon, InputAdornment, Link, Switch } from '@mui/material';
import Keycloak from 'keycloak-js';
import { isArray } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useResetRecoilState, useSetRecoilState } from "recoil";
import { Auth } from "../../Component/Api/Auth/AuthService";
import { IntermediateGlobalLoading } from "../../Component/Common/Components/Loading/IntermediateGlobalLoading";
import { PageLayout } from "../../Component/Common/Container/PageLayout";
import { LoginTypeResponse, ProcessLoginRequest, TokenRequest } from "../../Component/Model/SignIn";
import { ValidateEmailAddress, defaultObject } from "../../Component/Model/helpers";
import { coreTokenAtom, tokenAtom } from "../../State/Token.Atom";
import config from "../../config";
import { CustomDialogTitle } from "../Common/Custom/CustomDialogTitle";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { LoginTextField } from "../../Component/Common/Components/TextField/CustomTextField";
import { ConsolidationAtom } from "../../State/Consolidation.Atom";
import { EEScorecardAtom } from "../../State/EEScorecard.Atom";
import { ScorecardAtom } from "../../State/Scorecard.Atom";
import { VerificationCompanyAtom } from "../../State/VerificationCompany.Atom";
import './login-page.loginPage.css';
import { WSPScorecardAtom } from '../../State/WSPScorecard.Atom';
import { OrganisationAtom } from '../../State/Organisation.Atom';
import { BBBEEScorecardAtom } from '../../State/BBBEEScorecard.Atom';
import { UserAtom } from '../../State/user.Atom';
import { ClientAdvisorAtom } from '../../State/Advisory/ClientAdvisors.Atom';
import { ClientRegistrationAtom } from '../../State/Advisory/ClientRegistration.Atom';
import loginPattern from '../../assets/img/login/bee123_login_pattern.png';
import loginForeground from '../../assets/img/login/login_foreground.png';

export const LoginPage: React.FC = () => {

    const hrefLink = '#';
    const history = useHistory();
    const [showModal, setShowModal] = React.useState({
        open: false,
        name: '',
    });
    const [loginEmail, setloginEmail] = React.useState("");
    const [forgotEmail, setForgotEmail] = React.useState("");
    const [forgotPassword, setForgotPassword] = React.useState("");
    const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
    const [isUser, setIsUser] = React.useState(false);
    const [hasMFA, setHasMFA] = React.useState(false);
    const [rememberMe, setRememberMe] = React.useState(false);
    const [loginPassword, setloginPassword] = React.useState("");
    const [mfa, setMFA] = React.useState("");
    const [loginPasswordState, setloginPasswordState] = React.useState("");
    const [forgotEmailState, setForgotEmailState] = React.useState("");
    const [forgotPasswordState, setForgotPasswordState] = React.useState("");
    const [loginEmailState, setloginEmailState] = React.useState("");
    const [MFAState, setMFAState] = React.useState("");
    const [loginType, setLoginType] = React.useState<LoginTypeResponse>(defaultObject);
    const [token, setToken] = useRecoilState<string>(tokenAtom);
    const [coreToken, setCoreToken] = useRecoilState<string>(coreTokenAtom);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isForgotLoading, setIsForgotLoading] = React.useState(false);
    const [pageLoading, setPageLoading] = React.useState(false);
    const setClientAdvisors = useSetRecoilState(ClientAdvisorAtom);
    const resetScorecard = useResetRecoilState(ScorecardAtom);
    const resetScorecardType = useResetRecoilState(ConsolidationAtom);
    const resetScorecardData = useResetRecoilState(EEScorecardAtom);
    const resetVerificationCompany = useResetRecoilState(VerificationCompanyAtom);
    const resetWSPScorecard = useResetRecoilState(WSPScorecardAtom);
    const resetClientRegistration = useResetRecoilState(ClientRegistrationAtom);
    const resetOrganisation = useResetRecoilState(OrganisationAtom);
    const resetBBBEEScorecard = useResetRecoilState(BBBEEScorecardAtom);
    const resetUser = useResetRecoilState(UserAtom);

    const realm = localStorage.getItem('realm');
    const clientId = localStorage.getItem('clientId');


    let initOptions = {
        'url': config.keycloakUrl,
        'realm': realm || 'Development',
        'clientId': clientId || 'bee123'
    };
    let keycloak = new Keycloak(initOptions);


    keycloak.init({ responseMode: "query", checkLoginIframe: false });

    keycloak.onAuthSuccess = () => {
        if (keycloak.token! != null) {
            setCoreToken(keycloak.token);
            const loginParams = {
                loginType: 'redirect',
                tokens: {
                    accessToken: keycloak.token,
                    refreshToken: keycloak.refreshToken,
                }
            }
            const SSOFormData = new URLSearchParams();
            SSOFormData.append('loginType', loginParams.loginType);
            SSOFormData.append('tokens[accessToken]', loginParams.tokens.accessToken);
            SSOFormData.append('tokens[refreshToken]', loginParams.tokens.refreshToken!);
            setPageLoading(true)
            Auth.SSO(SSOFormData).then((res) => {
                if (res.data) {
                    setToken(res.data.access_token);
                    history.push({
                        pathname: '/home',
                        state: {
                            showPopup: true,
                        }
                    });
                }
            }).catch((err) => {
                if (err.response?.status === 403) {
                    toast.error(err.response.data);
                } else {
                    toast.error("Invalid username or password provided.");
                }
            }).finally(() => {
                setPageLoading(false);
            });

        }
    };

    const sendResetPassword = async () => {
        try {
            if (forgotPassword.length < 1) {
                setForgotPasswordState("error");
                toast.error("Please enter a username");
                return;
            }
            setIsForgotLoading(true);
            await Auth.forgotPassword(forgotPassword);
            toast.success("Email sent successfully");
            setShowModal({ name: '', open: false });
            setIsForgotLoading(false);
        } catch (error) {
            console.log(error);
            toast.success("If an account exists for the provided username, we will send you instructions on how to reset your password");
        }
        finally {
            setIsForgotLoading(false);
        }

    }

    const sendUserEmail = async () => {
        try {
            if (!ValidateEmailAddress(forgotEmail)) {
                setForgotEmailState("error");
                toast.error("Invalid email address");
                return;
            }
            setIsForgotLoading(true);
            await Auth.forgotUsername(forgotEmail);
            toast.success("Email sent successfully");
            setShowModal({ name: '', open: false });
        } catch (error) {
            console.log(error);
            toast.success("If an account exists for the provided email address, we will send you instructions on how to reset your password");
        } finally {
            setIsForgotLoading(false);
        }
    }

    const loginClick = async () => {

        setIsLoading(true);
        if (loginEmailState === "error") {
            setIsUser(false);
            setIsLoading(false);
            return;
        }

        try {
            const result = await Auth.getLoginType(loginEmail);
            setLoginType(result.data);
            if (result.data.LoginType === "redirect") {
                localStorage.setItem('realm', result.data.KeycloakRealmName);
                keycloak.realm = result.data.KeycloakRealmName;
                localStorage.setItem('clientId', result.data.KeycloakClientId);
                keycloak.clientId = result.data.KeycloakClientId;

                await keycloak.login({
                    loginHint: loginEmail,
                    idpHint: result.data.KeycloakDefaultIdp,
                    redirectUri: window.location.href,
                })
                return;
            }
            setloginEmailState("success");
            setIsUser(true);
            setIsLoading(false);
            document.getElementById("loginpassword")?.focus();
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            setloginEmailState("error");
            setIsUser(false);
        }

    };

    const loginwithQR = async () => {
        try {
            setIsLoading(true);
            resetAllData();
            if (MFAState === "error") {
                return;
            }
            const tokenRequest: TokenRequest = {
                RememberMe: rememberMe.toString(),
                grant_type: "password",
                username: loginEmail,
                password: loginPassword,
                loginType: loginType.LoginType,
                TwoFactorCode: mfa
            }
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('grant_type', tokenRequest.grant_type);
            bodyFormData.append('username', tokenRequest.username);
            bodyFormData.append('password', tokenRequest.password);
            bodyFormData.append('RememberMe', tokenRequest.RememberMe);
            bodyFormData.append('TwoFactorCode', tokenRequest.TwoFactorCode!);
            const result = await Auth.Token(bodyFormData);
            setToken(result.data.access_token);
            await coreLogin(tokenRequest.username, tokenRequest.password);
            setIsLoading(false);
        } catch (error: any) {
            const errorMessage = error.response?.data.error_description || "User authentication failed.";
            toast.error(errorMessage);
            setIsLoading(false);
        }
    }

    const loginwithPasswordClick = async () => {

        setIsLoading(true);
        resetAllData();
        if (loginPasswordState === "error") {
            setIsLoading(false);
            return;
        }
        const request: ProcessLoginRequest = {
            username: loginEmail,
            password: loginPassword,
            loginType: loginType.LoginType
        }
        try {
            const result = await Auth.ProcessLogin(request);
            setloginEmailState("success");
            setloginPasswordState("success");
            setIsUser(true);
            if (result.data.IsDirectLogin) {
                setRememberMe(false);
                const secondRequest: TokenRequest = {
                    RememberMe: rememberMe.toString(),
                    grant_type: "password",
                    username: loginEmail,
                    password: loginPassword,
                    loginType: loginType.LoginType
                }
                const bodyFormData = new URLSearchParams();
                bodyFormData.append('grant_type', secondRequest.grant_type);
                bodyFormData.append('username', secondRequest.username);
                bodyFormData.append('password', secondRequest.password);
                bodyFormData.append('RememberMe', secondRequest.RememberMe);
                const token = await Auth.Token(bodyFormData);
                setToken(token.data.access_token);
                await coreLogin(secondRequest.username, secondRequest.password);
            }
            if (!result.data.IsTwoFactorAuthenticationConfigured && !result.data.IsDirectLogin) {
                history.push({
                    pathname: `/twoFactorAuthentication`,
                    state: {
                        RememberMe: rememberMe.toString(),
                        grant_type: "password",
                        username: loginEmail,
                        password: loginPassword,
                        loginType: loginType.LoginType
                    }
                });
            }
            if (result.data.IsTwoFactorAuthenticationConfigured) {
                setHasMFA(true);
                document.getElementById("QRCode")?.focus();
            }
            setIsLoading(false);
        } catch (error: any) {
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
            console.log(error);
            setIsLoading(false);
        }

    };

    const coreLogin = async (username: string, password: string) => {
        setIsLoading(true);
        try {
            const result = await Auth.login(username, password);
            setCoreToken(result.data.token);
            history.push('/home');
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const resetAllData = () => {
        resetScorecard();
        resetScorecardData();
        resetScorecardType();
        resetVerificationCompany();
        resetWSPScorecard();
        resetClientRegistration();
        resetOrganisation();
        resetBBBEEScorecard();
        resetUser();
        localStorage.removeItem('coreToken');
        localStorage.removeItem('accessToken');
        setToken('');
        setCoreToken('');
    }

    const handleShowPassword = () => {
        setIsPasswordVisible(!isPasswordVisible);
    }

    if (pageLoading) {
        return <IntermediateGlobalLoading />
    }

    return (
        <PageLayout>
            <div className="login-page-root">

                <nav className="login-navbar">
                    <div className="Customlogo">
                        <a href="/"><img src="https://app.bee123.co.za/Content/images/BEE_Logo_slogann.png" height="50px" alt='BEE123 Logo' draggable={false}></img></a>
                    </div>
                    <ul className="login-navbar-links">
                        <li><a href="/#security" target="_blank" rel="noreferrer">Security</a></li>
                        <li><a href="/Content/StaticFiles/BEE123_Terms_and_Conditions_2023.pdf" target="_blank" rel="noreferrer">T&Cs</a></li>
                        <li><a href="https://www.bee123.co.za/contact/" target="_blank" rel="noreferrer">Contact Us</a></li>
                    </ul>
                </nav>

                <div className="login-content-area">

                    <div className="login-left-section">
                        <img src={loginPattern} className="login-pattern-img" alt="" aria-hidden="true" draggable={false} />
                        <img src={loginForeground} className="login-woman-img" alt="" aria-hidden="true" draggable={false} />
                    </div>

                    <div className="login-form-section">
                        <div className="login-form-inner">
                            <h1 className="login-title-new">Client Login</h1>

                            {!hasMFA &&
                                <>
                                    <LoginTextField
                                        error={loginEmailState === 'error'}
                                        placeholder="Username *"
                                        id="loginemail"
                                        fullWidth
                                        onChange={(event: any) => {
                                            if ((event.target.value == null)) {
                                                setloginEmailState("error");
                                            }
                                            setloginEmail(event.target.value);
                                        }}
                                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                            if (e.key === "Enter") {
                                                loginClick();
                                            }
                                        }}
                                        InputProps={
                                            <InputAdornment position="start">
                                                <EmailIcon />
                                            </InputAdornment>
                                        }
                                    />
                                    <Collapse in={isUser} sx={{ width: '100%' }}>
                                            <Box mt={2} width="100%">
                                                <LoginTextField
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end" style={{ cursor: 'pointer' }}>
                                                                <span onClick={handleShowPassword}>{isPasswordVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}</span>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    error={loginPasswordState === 'error'}
                                                    placeholder="Password *"
                                                    id="loginpassword"
                                                    fullWidth
                                                    onChange={(event: any) => {
                                                        if (event.target.value == null) {
                                                            setloginPasswordState("error");
                                                        }
                                                        setloginPassword(event.target.value);
                                                    }}
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                        if (e.key === "Enter") {
                                                            loginwithPasswordClick();
                                                        }
                                                    }}
                                                    type={isPasswordVisible ? "text" : "password"}
                                                />
                                            </Box>
                                            <Grid item xs sx={{ textAlign: 'center' }}>
                                                <Link href={hrefLink} sx={{ color: 'white !important', textDecoration: 'underline !important', '&:link': { textDecoration: 'underline !important' }, '&:visited': { textDecoration: 'underline !important' } }} variant="body2" onClick={() => setShowModal({ name: 'ForgotPassword', open: true })}>
                                                    Forgot Password?
                                                </Link>
                                            </Grid>
                                            <Dialog open={showModal.name === 'ForgotPassword' && showModal.open} onClose={() => setShowModal({ name: '', open: false })} aria-labelledby="form-dialog-title" fullWidth>
                                                <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowModal({ name: '', open: false })}>
                                                    Forgot Password
                                                </CustomDialogTitle>
                                                <DialogContent>
                                                    <FormControl fullWidth sx={{ m: 1 }}>
                                                        <LoginTextField
                                                            error={forgotPasswordState === 'error'}
                                                            placeholder="Username"
                                                            id="Username"
                                                            fullWidth
                                                            onChange={(event: any) => {
                                                                if ((event.target.value == null)) {
                                                                    setForgotPasswordState("error");
                                                                }
                                                                setForgotPassword(event.target.value);
                                                            }}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailIcon />
                                                                    </InputAdornment>
                                                                ),

                                                            }}
                                                            variant="standard"
                                                        />
                                                    </FormControl>
                                                </DialogContent>
                                                <DialogActions>
                                                    <LoadingButton loading={isForgotLoading} color='primary' onClick={() => sendResetPassword()}>Reset Password</LoadingButton>
                                                </DialogActions>
                                            </Dialog>
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <LoadingButton variant="contained" size="large" loading={isLoading} color="primary" onClick={loginwithPasswordClick} sx={{ textTransform: 'none', fontSize: '1.1rem', px: 10, py: 1.5, backgroundColor: '#ebb91d', color: '#ffffff', '&:hover': { backgroundColor: '#d4a619' } }}>
                                                    Login
                                                </LoadingButton>
                                            </Box>
                                    </Collapse>
                                    <Collapse in={!isUser}>
                                            <Grid item xs sx={{ textAlign: 'center' }}>
                                            <Link href={hrefLink} sx={{ color: 'white !important', textDecoration: 'underline !important', '&:link': { textDecoration: 'underline !important' }, '&:visited': { textDecoration: 'underline !important' } }} variant="body2" onClick={() => setShowModal({ name: 'ForgotUser', open: true })}>
                                                Forgot Username?
                                            </Link>
                                            </Grid>
                                            <Dialog open={showModal.name === 'ForgotUser' && showModal.open} onClose={() => setShowModal({ name: '', open: false })} aria-labelledby="form-dialog-title" fullWidth>
                                                <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowModal({ name: '', open: false })}>
                                                    Forgot Username
                                                </CustomDialogTitle>
                                                <DialogContent>
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <LoginTextField
                                                            error={forgotEmailState === "error"}
                                                            placeholder="Email Address"
                                                            id="emailAddress"
                                                            fullWidth
                                                            onChange={(event: any) => {
                                                                if ((event.target.value == null)) {
                                                                    setForgotEmailState("error");
                                                                }
                                                                setForgotEmail(event.target.value);
                                                            }}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <EmailIcon />
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </div>
                                                </DialogContent>
                                                <DialogActions>
                                                    <LoadingButton loading={isForgotLoading} color='primary' onClick={() => sendUserEmail()}>Email Username</LoadingButton>
                                                </DialogActions>
                                            </Dialog>

                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <LoadingButton size="large" variant="contained" loading={isLoading} color="primary" onClick={loginClick} sx={{ textTransform: 'none', fontSize: '1.1rem', px: 10, py: 1.5, backgroundColor: '#ebb91d', color: '#ffffff', '&:hover': { backgroundColor: '#d4a619' } }}>
                                                    Proceed
                                                </LoadingButton>
                                            </Box>
                                    </Collapse>
                                </>
                            }
                            {hasMFA &&
                                <>
                                    <Grid item xs={12}>
                                        <LoginTextField
                                            error={MFAState === "error"}
                                            placeholder="Code"
                                            id="QRCode"
                                            fullWidth
                                            onChange={
                                                (event: any) => {
                                                    if ((event.target.value == null)) {
                                                        setMFAState("error");
                                                    }
                                                    setMFA(event.target.value);
                                                }
                                            }
                                            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                if (e.key === "Enter") {
                                                    loginwithQR();
                                                }
                                            }}
                                            InputProps={
                                                <InputAdornment position="start">
                                                    <Icon>
                                                        qr_code
                                                    </Icon>
                                                </InputAdornment>
                                            }
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={rememberMe}
                                                    onChange={(event) =>
                                                        setRememberMe(event.target.checked)
                                                    }
                                                    value="rememberMe"
                                                />
                                            }
                                            label="Remember Me?"
                                            sx={{ '& .MuiFormControlLabel-label': { color: 'white !important' } }}
                                        />
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <LoadingButton variant="contained" size="large" loading={isLoading} color="primary" onClick={loginwithQR} sx={{ backgroundColor: 'rgb(212, 166, 25)', '&:hover': { backgroundColor: 'rgb(190, 148, 20)' } }}>
                                                Submit
                                            </LoadingButton>
                                        </Box>
                                    </Grid>
                                </>
                            }
                        </div>
                        <div className="login-footer-new">
                            Send us an <a className="login-page-link" title="Email support@bee123.co.za"
                                href="mailto:sales@bee123.co.za?subject=Support Query&amp;">email</a> if you are
                            new to BEE123 and need to setup an account.
                            <br /> By logging in, you agree to the <a className="login-page-link" href="/Content/StaticFiles/BEE123_Terms_and_Conditions_2023.pdf"
                                    target="_blank" rel="noreferrer">terms & conditions</a> of this site.
                        </div>
                    </div>
                </div>

            </div>
        </PageLayout>
    )

}
